/** @format
 * 常用业务跳转
 * https://cf.jd.com/pages/viewpage.action?pageId=98368344
 * OpenApp协议及统一跳转协议
 * https://cf.jd.com/pages/viewpage.action?pageId=73644612
 */

export const openapp = {
  //跳转到商品详情页
  //https://cf.jd.com/pages/viewpage.action?pageId=300852699
  goodsDetail: (skuId: number | string) =>
    `openapp.jdmobile://virtual?params={"category":"jump","des":"productDetail","skuId":"${skuId}","landPageId":"jshop.cx.mobile"}`,
};
